module.exports = __webpack_public_path__ + "static/img/time.a41639b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/time.png
// module id = qKtB
// module chunks = 2